// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import PropTypes from "prop-types";
import { Button, Toastr } from "@revvsales/components";

// Components Imports
import StatusDropdown from "../../../QuotationTopbar/StatusDropdown";

// Actions Imports
import {
  sendDocForApproval,
  fetchAndUpdateDocMeta,
  approvalStatusCheck,
} from "../../../../actions/DocumentActions";

class DocApproval extends Component {
  state = {
    comment: "",
    showBtnLoader: false,
  };

  _closePopup = () => {
    this.props.onClose();
  };

  _onCommentMsgChange = e => {
    this.setState({ comment: e.target.value });
  };

  _sendDocForApproval = () => {
    const payload = {
      event_id: this.props.workFlowEventID,
      entity: "DEAL",
      entity_id: this.props.documentID,
      user_comment: this.state.comment,
    };

    this.setState({ showBtnLoader: true });
    this.props
      .sendDocForApproval(payload)
      .then(() => {
        Toastr.showToastr({
          className: "is-success",
          message: "Document sent for Approval successfully",
          timeout: 3000,
        });
        this.props.fetchAndUpdateDocMeta(this.props.documentNo);
        this.props.approvalStatusCheck(this.props.documentID);
        this._closePopup();
      })
      .catch(() => {
        Toastr.showToastr({
          className: "is-failure",
          message: "Oops, Something went wrong!!",
          timeout: 3000,
        });
        this.setState({ showBtnLoader: false });
      });
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} center>
        <div
          className="docapproval-container"
          data-test="docapproval-container">
          <div className="docapproval-title" data-test="docapproval-title">
            Your document requires approval
          </div>

          <div className="docapproval-approver-container">
            <p className="docapproval-approver-heading">
              The following users need to approve your document.
            </p>
            {this.props.approversList.map(data => (
              <div
                className="docapproval-approver-item-container"
                key={data.id}>
                <div className="docapproval-approver-item-reason">
                  <span>{data.triggeMessage}</span>
                </div>
                <div className="docapproval-approver-item-title">Approvers</div>
                {/* Groups Approvers Listing */}
                <div className="docapproval-approvers-list">
                  {data.groupApprovers.map(groupApprover => (
                    <div
                      className="docapproval-approver-group-container"
                      key={groupApprover.id}>
                      <span className="docapproval-approver-group-icon">
                        <FontAwesomeIcon icon={["far", "users"]} />
                      </span>
                      <span className="docapproval-approver-group-name">
                        {groupApprover.group_name || "-"}
                      </span>
                    </div>
                  ))}
                  {/* Approvers Listing */}
                  {data.approvers.map(approver => (
                    <div
                      className="docapproval-approver-user-container"
                      key={approver.id}>
                      <span className="docapproval-approver-user-img">
                        <img src={approver.image_url} alt="Approvar Profile" />
                      </span>
                      <span className="docapproval-approver-user-name">
                        {approver.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="docapproval-note-container">
            <p className="docapproval-note-title">
              Please add a comment to support your decision. (Recommended)
            </p>
            <textarea
              rows="5"
              value={this.state.comment}
              onChange={e => this._onCommentMsgChange(e)}
              data-test="docapproval-textarea"
            />
          </div>

          {/* ----------- Update Document Status Section ----------- */}
          {this.props.hasPermissionToUpdateDocStatus && (
            <div className="docapproval-status-container">
              <div className="docapproval-status-label">
                <span>Also update document status to</span>
              </div>
              <div className="docapproval-status-dropdown">
                <StatusDropdown
                  currentStatus={this.props.documentStatus}
                  docId={this.props.documentID}
                  currentTag={this.props.documentTag}
                  source="Popup"
                />
              </div>
            </div>
          )}
        </div>
        <div className="docapproval-footer">
          <Fragment>
            <Button
              className="docapproval-cancel-btn"
              data-test="docapproval-cancel-btn"
              onClick={this._closePopup}>
              Wait, let me review again
            </Button>
            <Button
              isLoading={this.state.showBtnLoader}
              data-test="docapproval-approve-btn"
              onClick={this._sendDocForApproval}>
              Yes, send for internal review
            </Button>
          </Fragment>
        </div>
      </Modal>
    );
  }
}

DocApproval.propTypes = {
  onClose: PropTypes.func.isRequired,
  workFlowEventID: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const {
    docAnalysis: approversList,
    document: {
      docNo: documentNo,
      documentStatus,
      documentTag,
      id: documentID,
    },
    showWhoHasAccessForRecipients: hasPermissionToUpdateDocStatus,
  } = state.DocumentStore;

  return {
    approversList,
    documentID,
    documentNo,
    documentStatus,
    documentTag,
    hasPermissionToUpdateDocStatus,
  };
};

const mapDispatchToProps = {
  approvalStatusCheck,
  fetchAndUpdateDocMeta,
  sendDocForApproval,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocApproval);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/DocApproval/index.js